export const API_URL = "https://api.rateyourdate.xyz";
